import React, { useState, useEffect } from 'react';
import ProfileChoice from '../ProfileChoice';
import { QRCodeSVG as QRCode } from 'qrcode.react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import Header from '../Layout/Header';
import Footer from '../Layout/Footer';
import AdSlot from '../AdSlot';
import EmailPopup from '../EmailPopup';

const FONTS = [
  { name: 'Arial', family: 'Arial, sans-serif', label: 'Arial' },
  { name: 'Playfair', family: "'Playfair Display', serif", label: 'Playfair' },
  { name: 'Montserrat', family: "'Montserrat', sans-serif", label: 'Montserrat' },
  { name: 'Cormorant', family: "'Cormorant Garamond', serif", label: 'Cormorant' },
  { name: 'Bebas', family: "'Bebas Neue', sans-serif", label: 'BEBAS' },
];
const PALETTES = [
  { name: 'Noir', accent: '#FF0066', bandeau: '#1A1A1A', texte: '#ffffff' },
  { name: 'Nude', accent: '#C4916A', bandeau: '#2C2C2C', texte: '#F2D6C8' },
  { name: 'Rose', accent: '#E8A0B4', bandeau: '#3D2B2B', texte: '#FFF0F3' },
  { name: 'Bleu', accent: '#7EB5D6', bandeau: '#1C2E3D', texte: '#E8F4FF' },
  { name: 'Beige', accent: '#B8966E', bandeau: '#F5EFE6', texte: '#2C2C2C' },
  { name: 'Vert', accent: '#8BBF9F', bandeau: '#1D2E27', texte: '#E8F5EE' },
];

const TRANSLATIONS = {
  FR: {
    site: {
      download: 'TÉLÉCHARGER VOTRE COMPOSITE', generating: 'GÉNÉRATION...',
      add: '+ AJOUTER', connect: 'SE CONNECTER', register: "S'INSCRIRE",
      clickHere: 'CLIQUER', dragHint: 'Ajoutez des photos via le bouton ci-contre',
      recto: 'RECTO', verso: 'VERSO', templates: 'TEMPLATES', colors: 'COULEURS',
      infos: 'INFORMATIONS', fond: 'FOND', accent: 'ACCENT',
      compoLang: 'LANGUE', border: 'CONTOUR', enable: 'ACTIVER',
      color: 'COULEUR', thickness: 'ÉPAISSEUR', face: 'FACE DU COMPOSITE',
      texte: 'TEXTE',
      preview: 'APERÇU DU COMPOSITE',
      nav: ['Accueil', 'Le composite card', 'Tarifs', 'FAQ', 'Contact'],
      tagline: 'LA CARTE DE VISITE DU MANNEQUIN',
      fields: {
        prenom: 'Prénom', nom: 'Nom', email: 'Email', telephone: 'Téléphone',
        agence: 'Agence / Site web', instagram: 'Réseau social', taille: 'Taille (cm)',
        poitrine: 'Tour de poitrine', tour_taille: 'Tour de taille',
        hanches: 'Tour de hanches', pointure: 'Pointure',
        yeux: 'Couleur des yeux', cheveux: 'Couleur des cheveux'
      },
      fieldsComedien: {
        prenom: 'Prénom', nom: 'Nom', email: 'Email', telephone: 'Téléphone',
        agence: 'Agent / Site web', instagram: 'Réseau social',
        taille: 'Taille (cm)', poids: 'Poids (kg)',
        yeux: 'Couleur des yeux', cheveux: 'Couleur des cheveux',
        voix: 'Type de voix', langues: 'Langues parlées',
        demo: 'Lien bande démo'
      }
    },
    compo: {
      taille: 'TAILLE', poitrine: 'POITRINE', tour_taille: 'TAILLE',
      hanches: 'HANCHES', pointure: 'POINTURE', yeux: 'YEUX', cheveux: 'CHEVEUX',
      agence: 'AGENCE', prenom: 'PRÉNOM', nom: 'NOM'
    },
    compoComedien: {
      taille: 'TAILLE', poids: 'POIDS', yeux: 'YEUX', cheveux: 'CHEVEUX',
      voix: 'VOIX', langues: 'LANGUES', demo: 'BANDE DÉMO'
    }
  },
  EN: {
    site: {
      download: 'DOWNLOAD YOUR COMPOSITE', generating: 'GENERATING...',
      add: '+ ADD', connect: 'LOG IN', register: 'SIGN UP',
      clickHere: 'CLICK', dragHint: 'Add photos via the button on the left',
      recto: 'FRONT', verso: 'BACK', templates: 'TEMPLATES', colors: 'COLORS',
      infos: 'INFORMATION', accent: 'ACCENT',
      compoLang: 'LANGUAGE', border: 'BORDER', enable: 'ENABLE',
      color: 'COLOR', thickness: 'WIDTH', face: 'COMPOSITE FACE',
      fond: 'BG', texte: 'TEXT',
      preview: 'COMPOSITE PREVIEW',
      nav: ['Home', 'The composite card', 'Pricing', 'FAQ', 'Contact'],
      tagline: 'THE MODEL COMPOSITE CARD MAKER',
      fields: {
        prenom: 'First name', nom: 'Last name', email: 'Email', telephone: 'Phone',
        agence: 'Agency / Website', instagram: 'Social media', taille: 'Height (cm)',
        poitrine: 'Bust', tour_taille: 'Waist', hanches: 'Hips',
        pointure: 'Shoe size', yeux: 'Eye color', cheveux: 'Hair color'
      },
      fieldsComedien: {
        prenom: 'First name', nom: 'Last name', email: 'Email', telephone: 'Phone',
        agence: 'Agent / Website', instagram: 'Social media',
        taille: 'Height (cm)', poids: 'Weight (kg)',
        yeux: 'Eye color', cheveux: 'Hair color',
        voix: 'Voice type', langues: 'Languages',
        demo: 'Demo reel link'
      }
    },
    compo: {
      taille: 'HEIGHT', poitrine: 'BUST', tour_taille: 'WAIST',
      hanches: 'HIPS', pointure: 'SHOE', yeux: 'EYES', cheveux: 'HAIR',
      agence: 'AGENCY', prenom: 'FIRST NAME', nom: 'LAST NAME'
    },
    compoComedien: {
      taille: 'HEIGHT', poids: 'WEIGHT', yeux: 'EYES', cheveux: 'HAIR',
      voix: 'VOICE', langues: 'LANGUAGES', demo: 'DEMO REEL'
    }
  }
};

let dragGalleryIndex = null;
const emptySlot = () => ({ base64: null, zoom: 1, posX: 50, posY: 50, warning: false });
const PANEL_BG = 'linear-gradient(135deg, #e8e8e8 0%, #d0d0d0 100%)';
const BG = '#2a2a2a';

const Block = ({ children, style = {} }) => (
  <div style={{ position: 'relative', backgroundColor: 'rgba(255,255,255,0.28)', marginBottom: '8px', padding: '10px', ...style }}>
    {[
      { top: 0, left: 0, borderTop: '1px solid #242424', borderLeft: '1px solid #242424', width: 4, height: 4 },
      { top: 0, right: 0, borderTop: '1px solid #242424', borderRight: '1px solid #242424', width: 4, height: 4 },
      { bottom: 0, left: 0, borderBottom: '1px solid #242424', borderLeft: '1px solid #242424', width: 4, height: 4 },
      { bottom: 0, right: 0, borderBottom: '1px solid #242424', borderRight: '1px solid #242424', width: 4, height: 4 },
    ].map((corner, i) => (
      <div key={i} style={{ position: 'absolute', ...corner }} />
    ))}
    {children}
  </div>
);

const SectionLabel = ({ text }) => (
  <p style={{ color: '#555', fontSize: '10px', letterSpacing: '2px', fontWeight: '700', margin: '0 0 10px', textTransform: 'uppercase' }}>{text}</p>
);

const Toggle = ({ value, onChange }) => (
  <div onClick={() => onChange(!value)} style={{
    width: '32px', height: '16px', borderRadius: '8px', cursor: 'pointer',
    backgroundColor: value ? '#FF0066' : '#ccc', position: 'relative', transition: 'all 0.2s', flexShrink: 0
  }}>
    <div style={{ position: 'absolute', top: '2px', left: value ? '18px' : '2px', width: '12px', height: '12px', borderRadius: '50%', backgroundColor: '#fff', transition: 'all 0.2s' }} />
  </div>
);

const TemplateVignette = ({ id, active }) => {
  const outer = active ? '#FF0066' : '#d8d8d8';
  const photo = '#c4c4c4';
  const bar = '#1a1a1a';
  const bg = '#ffffff';
  const s = { width: '100%', height: '100%' };
  const vignettes = {
    t1: (<svg {...s} viewBox="0 0 44 60"><rect x="0" y="0" width="44" height="60" fill={bg} stroke={outer} strokeWidth="1.5"/><rect x="4" y="4" width="36" height="43" fill={photo}/><rect x="0" y="50" width="44" height="10" fill={bar}/></svg>),
    t2: (<svg {...s} viewBox="0 0 44 60"><rect x="0" y="0" width="44" height="60" fill={bg} stroke={outer} strokeWidth="1.5"/><rect x="4" y="4" width="36" height="20" fill={photo}/><rect x="4" y="26" width="36" height="21" fill={photo}/><rect x="0" y="50" width="44" height="10" fill={bar}/></svg>),
    t3: (<svg {...s} viewBox="0 0 44 60"><rect x="0" y="0" width="44" height="60" fill={bg} stroke={outer} strokeWidth="1.5"/><rect x="4" y="4" width="36" height="25" fill={photo}/><rect x="4" y="31" width="17" height="17" fill={photo}/><rect x="23" y="31" width="17" height="17" fill={photo}/><rect x="0" y="50" width="44" height="10" fill={bar}/></svg>),
    t4: (<svg {...s} viewBox="0 0 44 60"><rect x="0" y="0" width="44" height="60" fill={bg} stroke={outer} strokeWidth="1.5"/><rect x="4" y="4" width="17" height="14" fill={photo}/><rect x="23" y="4" width="17" height="14" fill={photo}/><rect x="4" y="20" width="36" height="28" fill={photo}/><rect x="0" y="50" width="44" height="10" fill={bar}/></svg>),
    t5: (<svg {...s} viewBox="0 0 44 60"><rect x="0" y="0" width="44" height="60" fill={bg} stroke={outer} strokeWidth="1.5"/><rect x="4" y="4" width="17" height="21" fill={photo}/><rect x="23" y="4" width="17" height="21" fill={photo}/><rect x="4" y="27" width="17" height="21" fill={photo}/><rect x="23" y="27" width="17" height="21" fill={photo}/><rect x="0" y="50" width="44" height="10" fill={bar}/></svg>),
    t6: (<svg {...s} viewBox="0 0 44 60"><rect x="0" y="0" width="44" height="60" fill={bg} stroke={outer} strokeWidth="1.5"/><rect x="4" y="4" width="17" height="10" fill={photo}/><rect x="4" y="16" width="17" height="10" fill={photo}/><rect x="23" y="4" width="17" height="22" fill={photo}/><rect x="4" y="28" width="17" height="20" fill={photo}/><rect x="23" y="28" width="17" height="9" fill={photo}/><rect x="23" y="39" width="17" height="9" fill={photo}/><rect x="0" y="50" width="44" height="10" fill={bar}/></svg>),
    t7: (<svg {...s} viewBox="0 0 44 60"><rect x="0" y="0" width="44" height="60" fill={bg} stroke={outer} strokeWidth="1.5"/><rect x="4" y="4" width="17" height="22" fill={photo}/><rect x="23" y="4" width="17" height="10" fill={photo}/><rect x="23" y="16" width="17" height="10" fill={photo}/><rect x="4" y="28" width="17" height="9" fill={photo}/><rect x="4" y="39" width="17" height="9" fill={photo}/><rect x="23" y="28" width="17" height="20" fill={photo}/><rect x="0" y="50" width="44" height="10" fill={bar}/></svg>),
    t8: (<svg {...s} viewBox="0 0 44 60"><rect x="0" y="0" width="44" height="60" fill={bg} stroke={outer} strokeWidth="1.5"/><rect x="4" y="4" width="8" height="9" fill={photo}/><rect x="14" y="4" width="7" height="9" fill={photo}/><rect x="4" y="15" width="8" height="9" fill={photo}/><rect x="14" y="15" width="7" height="9" fill={photo}/><rect x="23" y="4" width="17" height="10" fill={photo}/><rect x="23" y="16" width="17" height="10" fill={photo}/><rect x="4" y="28" width="17" height="9" fill={photo}/><rect x="4" y="39" width="17" height="9" fill={photo}/><rect x="23" y="28" width="17" height="20" fill={photo}/><rect x="0" y="50" width="44" height="10" fill={bar}/></svg>),
  };
  return vignettes[id] || null;
};

const TEMPLATES = [
  { id: 't1', name: 'Full' }, { id: 't2', name: '2H' }, { id: 't3', name: '1+2' },
  { id: 't4', name: '2+1' }, { id: 't5', name: '4' }, { id: 't6', name: 'Mix A' },
  { id: 't7', name: 'Mix B' }, { id: 't8', name: 'Mix C' },
];

function Editor() {
  const [profile, setProfile] = useState(null);
  const [slots, setSlots] = useState(Array.from({ length: 20 }, emptySlot));
  const [gallery, setGallery] = useState([]);
  const [face, setFace] = useState('recto');
  const [rectoTemplate, setRectoTemplate] = useState('t1');
  const [versoTemplate, setVersoTemplate] = useState('t5');
  const [palette, setPalette] = useState(PALETTES[0]);
  const [exporting, setExporting] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showDownloadTip, setShowDownloadTip] = useState(false);
  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);
  const [showLoadingAd, setShowLoadingAd] = useState(false);
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [loadingAd, setLoadingAd] = useState({ active: false });
  const loadingAdRef = React.useRef({ active: false });
  useEffect(() => {
    fetch('/api/ad-config')
      .then(res => res.json())
      .then(data => { 
        if (data['loading-ad']) {
          setLoadingAd(data['loading-ad']);
          loadingAdRef.current = data['loading-ad'];
        }
      })
      .catch(() => {});
  }, []);
  const [hoveredSlot, setHoveredSlot] = useState(null);
  const [siteLang, setSiteLang] = useState('FR');
  const [compoLang, setCompoLang] = useState('FR');
  const [borderEnabled, setBorderEnabled] = useState(false);
  const [borderColor, setBorderColor] = useState('#ffffff');
  const [borderSize, setBorderSize] = useState(2);
  const [font, setFont] = useState(FONTS[0]);
  const [fontOpen, setFontOpen] = useState(window.innerWidth <= 1920);
  const [isLaptop, setIsLaptop] = useState(window.innerWidth <= 1920);
  const [infos, setInfos] = useState({
    prenom: '', nom: '', agence: '', taille: '',
    poitrine: '', tour_taille: '', hanches: '',
    pointure: '', yeux: '', cheveux: '', email: '',
    telephone: '', instagram: '',
    poids: '', voix: '', langues: '', demo: ''
  });

  useEffect(() => {
    const handleResize = () => setIsLaptop(window.innerWidth <= 1920);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      const el = document.getElementById('editor-top');
      if (el) el.scrollIntoView();
    }, 100);
  }, []);

  const t = TRANSLATIONS[siteLang].site;
  const c = TRANSLATIONS[compoLang].compo;
  const fields = Object.entries(TRANSLATIONS[siteLang].site.fields).map(([key, label]) => ({ key, label }));
  const handleInfo = (key, value) => setInfos(prev => ({ ...prev, [key]: value }));
  const borderGap = borderEnabled ? `${borderSize}px` : '1px';
  const borderBg = borderEnabled ? borderColor : '#fff';

  const PANEL_W = isLaptop ? '180px' : '200px';
  const COMPO_W = isLaptop ? 480 : 600;
  const COMPO_H = isLaptop ? 680 : 850;

  const fileToBase64 = (file, maxSize = 2400) => new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let w = img.width, h = img.height;
        if (w > maxSize || h > maxSize) {
          if (w > h) { h = Math.round(h * maxSize / w); w = maxSize; }
          else { w = Math.round(w * maxSize / h); h = maxSize; }
        }
        canvas.width = w; canvas.height = h;
        canvas.getContext('2d').drawImage(img, 0, 0, w, h);
        resolve(canvas.toDataURL('image/jpeg', 1.0));
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });

  const checkResolution = (file) => new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(img.width >= 1000);
    img.src = URL.createObjectURL(file);
  });

  const loadFileToSlotAndGallery = async (file, slotIndex) => {
    const base64 = await fileToBase64(file);
    const ok = await checkResolution(file);
    const photoObj = { base64, url: URL.createObjectURL(file), warning: !ok };
    setGallery(prev => prev.some(p => p.base64 === base64) ? prev : [...prev, photoObj]);
    setSlots(prev => {
      const next = [...prev];
      next[slotIndex] = { base64, zoom: 1, posX: 50, posY: 50, warning: !ok };
      return next;
    });
  };

  const loadFilesToGallery = async (files) => {
    const MAX = 16;
    setGallery(prev => {
      const remaining = MAX - prev.length;
      if (remaining <= 0) {
        alert(siteLang === 'FR' ? 'Maximum 16 photos atteint.' : 'Maximum of 16 photos reached.');
        return prev;
      }
      const filesToProcess = Array.from(files).slice(0, remaining);
      if (filesToProcess.length < files.length) {
        alert(siteLang === 'FR' ? `Seulement ${filesToProcess.length} photo(s) ajoutée(s) — maximum 16 atteint.` : `Only ${filesToProcess.length} photo(s) added — maximum of 16 reached.`);
      }
      Promise.all(filesToProcess.map(async (file) => {
        const base64 = await fileToBase64(file);
        const ok = await checkResolution(file);
        return { base64, url: URL.createObjectURL(file), warning: !ok };
      })).then(processed => setGallery(p => [...p, ...processed]));
      return prev;
    });
  };

  const removeFromGallery = (index) => {
    const msg = siteLang === 'FR'
      ? 'Attention ! Cette photo sera également supprimée du composite. Confirmer ?'
      : 'Warning! This photo will also be removed from the composite. Confirm?';
    if (!window.confirm(msg)) return;
    const photoToRemove = gallery[index].base64;
    setGallery(prev => prev.filter((_, i) => i !== index));
    setSlots(prev => prev.map(slot => slot.base64 === photoToRemove ? emptySlot() : slot));
  };

  const openFilePicker = (slotIndex) => {
    const input = document.createElement('input');
    input.type = 'file'; input.accept = 'image/*';
    input.onchange = async (e) => { if (e.target.files[0]) await loadFileToSlotAndGallery(e.target.files[0], slotIndex); };
    input.click();
  };

  const openGalleryPicker = () => {
    const input = document.createElement('input');
    input.type = 'file'; input.accept = 'image/*'; input.multiple = true;
    input.onchange = async (e) => { if (e.target.files.length) await loadFilesToGallery(e.target.files); };
    input.click();
  };

  const adjustZoom = (slotIndex, delta) => {
    setSlots(prev => {
      const next = [...prev];
      next[slotIndex] = { ...next[slotIndex], zoom: Math.min(3, Math.max(1, next[slotIndex].zoom + delta)) };
      return next;
    });
  };

  const exportPDF = async (withWatermark = false) => {
    if (!localStorage.getItem('compify-user-email') && !withWatermark) {
      setShowPopup(true);
      return;
    }
    setExporting(true);
    setHoveredSlot(null);

    if (loadingAdRef.current.active) {
      setLoadingProgress(0);
      setShowLoadingAd(true);
      await new Promise(resolve => {
        let progress = 0;
        const interval = setInterval(() => {
          progress += 100 / 35;
          setLoadingProgress(Math.min(100, Math.round(progress)));
          if (progress >= 100) { clearInterval(interval); resolve(); }
        }, 100);
      });
      setShowLoadingAd(false);
    }

    await new Promise(r => setTimeout(r, 300));

    const captureCanvas = async () => {
      return html2canvas(document.getElementById('composite-preview'), {
        scale: 3,
        useCORS: true,
        allowTaint: false,
        imageTimeout: 0,
        letterRendering: true,
        logging: false,
      });
    };

    const addWatermark = (pdf) => {
      if (!withWatermark) return;
      pdf.setFontSize(11);
      pdf.setTextColor(180, 180, 180);
      pdf.setFont('helvetica', 'normal');
      for (let y = 20; y < 210; y += 40) {
        for (let x = 10; x < 148; x += 60) {
          pdf.saveGraphicsState();
          pdf.text('compify.fr', x, y, { angle: 35 });
          pdf.restoreGraphicsState();
        }
      }
    };

    const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a5' });
    const mmW = 148;

    setFace('recto');
    await new Promise(r => setTimeout(r, 700));
    const rectoCanvas = await captureCanvas();
    const mmH = mmW * rectoCanvas.height / rectoCanvas.width;
    pdf.addImage(rectoCanvas.toDataURL('image/jpeg', 0.85), 'JPEG', 0, 0, mmW, mmH);
    addWatermark(pdf);

    pdf.addPage();
    setFace('verso');
    await new Promise(r => setTimeout(r, 700));
    const versoCanvas = await captureCanvas();
    pdf.addImage(versoCanvas.toDataURL('image/jpeg', 0.85), 'JPEG', 0, 0, mmW, mmH);
    addWatermark(pdf);

    const pdfBlob = pdf.output('bloburl');
    setPdfBlobUrl(pdfBlob);
    window.open(pdfBlob, '_blank');
    setShowDownloadTip(true);
    setFace('recto');
    setExporting(false);
  };

  const warningMsg = siteLang === 'FR'
    ? 'Résolution insuffisante — minimum 1000px recommandé'
    : 'Low resolution — minimum 1000px recommended';

  const currentTemplate = face === 'recto' ? rectoTemplate : versoTemplate;
  const currentOffset = face === 'recto' ? 0 : 10;

  const PhotoSlot = ({ slotIndex, style }) => {
    const photo = slots[slotIndex];
    const isHovered = hoveredSlot === slotIndex;
    const slotRef = React.useRef(null);

    const handleMouseDown = (e) => {
      if (!photo.base64) return;
      e.preventDefault(); e.stopPropagation();
      const isSwap = e.shiftKey;
      const startX = e.clientX, startY = e.clientY;
      const startPosX = photo.posX, startPosY = photo.posY;
      let swapTarget = null;

      const onMouseMove = (e) => {
        e.preventDefault();
        if (isSwap) {
          const el = document.elementFromPoint(e.clientX, e.clientY);
          const slotEl = el?.closest('[data-slot]');
          if (slotEl) swapTarget = parseInt(slotEl.dataset.slot);
          return;
        }
        const dx = (e.clientX - startX) * 0.3;
        const dy = (e.clientY - startY) * 0.3;
        setSlots(prev => {
          const next = [...prev];
          next[slotIndex] = { ...next[slotIndex], posX: Math.min(100, Math.max(0, startPosX - dx)), posY: Math.min(100, Math.max(0, startPosY - dy)) };
          return next;
        });
      };

      const onMouseUp = () => {
        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('mouseup', onMouseUp);
        if (isSwap && swapTarget !== null && swapTarget !== slotIndex) {
          setSlots(prev => {
            const next = [...prev];
            const temp = { ...next[slotIndex] };
            next[slotIndex] = { ...next[swapTarget] };
            next[swapTarget] = temp;
            return next;
          });
        }
      };
      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('mouseup', onMouseUp);
    };

    return (
      <div ref={slotRef} data-slot={slotIndex} style={{
        ...style, position: 'relative', overflow: 'hidden',
        backgroundColor: '#f5f5f5',
        outline: 'none',
        cursor: photo.base64 ? 'move' : 'pointer', boxSizing: 'border-box'
      }}
        onMouseDown={handleMouseDown}
        onDrop={(e) => {
          if (dragGalleryIndex !== null) {
            const gPhoto = gallery[dragGalleryIndex];
            if (gPhoto) {
              setSlots(prev => {
                const next = [...prev];
                next[slotIndex] = { base64: gPhoto.base64, zoom: 1, posX: 50, posY: 50, warning: gPhoto.warning || false };
                return next;
              });
            }
            dragGalleryIndex = null;
          }
        }}
        onMouseEnter={() => setHoveredSlot(slotIndex)}
        onMouseLeave={() => setHoveredSlot(null)}
        onClick={() => { if (!photo.base64) openFilePicker(slotIndex); }}
      >
        {photo.base64 && (
          <div style={{
            position: 'absolute', inset: 0,
            backgroundImage: `url(${photo.base64})`,
            backgroundSize: 'cover',
            backgroundPosition: `${photo.posX}% ${photo.posY}%`,
            transform: `scale(${photo.zoom})`,
            transformOrigin: `${photo.posX}% ${photo.posY}%`,
            pointerEvents: 'none'
          }} />
        )}
        {!photo.base64 && (
          <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: '8px', pointerEvents: 'none', padding: '8px', textAlign: 'center' }}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#FF0066" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.4">
              <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/>
            </svg>
            <span style={{ color: '#999', fontSize: '8px', opacity: 0.7, letterSpacing: '1px', lineHeight: 1.4 }}>
              {siteLang === 'FR' ? 'Cliquez pour\najouter une photo' : 'Click to\nadd a photo'}
            </span>
          </div>
        )}
        {photo.warning && (
          <div onMouseEnter={e => { const tip = document.getElementById('warning-tip'); if (tip) { tip.style.display = 'block'; tip.style.left = (e.clientX + 10) + 'px'; tip.style.top = (e.clientY + 10) + 'px'; } }}
            onMouseLeave={() => { const tip = document.getElementById('warning-tip'); if (tip) tip.style.display = 'none'; }}
            style={{ position: 'absolute', top: 6, left: 6, zIndex: 2 }}>
            <div style={{ backgroundColor: '#E8A000', color: '#fff', fontSize: '13px', width: '24px', height: '24px', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'help' }}>⚠</div>
          </div>
        )}
        {photo.base64 && isHovered && !exporting && (
          <div style={{ position: 'absolute', bottom: 6, right: 6, zIndex: 2, display: 'flex', gap: '3px' }}>
            {[['−', -0.15], ['+', 0.15]].map(([label, delta]) => (
              <button key={label} onMouseDown={e => { e.preventDefault(); e.stopPropagation(); adjustZoom(slotIndex, delta); }}
                style={{ width: '24px', height: '24px', backgroundColor: 'rgba(0,0,0,0.6)', color: '#fff', border: 'none', borderRadius: '3px', cursor: 'pointer', fontSize: '16px', fontWeight: '700', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0, lineHeight: 1 }}>
                {label}
              </button>
            ))}
            <button onMouseDown={e => { e.preventDefault(); e.stopPropagation();
              setSlots(prev => { const next = [...prev]; next[slotIndex] = emptySlot(); return next; }); }}
              style={{ width: '24px', height: '24px', backgroundColor: 'rgba(255,0,102,0.8)', color: '#fff', border: 'none', borderRadius: '3px', cursor: 'pointer', fontSize: '14px', fontWeight: '700', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0, lineHeight: 1 }}>
              ×
            </button>
          </div>
        )}
      </div>
    );
  };

  const PhotoArea = ({ children }) => (
    <div style={{
      flex: 1, display: 'flex', flexDirection: 'column', gap: borderGap,
      backgroundColor: borderBg,
      paddingTop: borderEnabled ? `${borderSize}px` : '0',
      paddingLeft: borderEnabled ? `${borderSize}px` : '0',
      paddingRight: borderEnabled ? `${borderSize}px` : '0',
      paddingBottom: borderEnabled ? `${borderSize}px` : '0',
    }}>
      {children}
    </div>
  );

  const BandeauRecto = () => (
    <div style={{ backgroundColor: palette.bandeau, padding: '14px 24px', flexShrink: 0, minHeight: '70px', boxSizing: 'border-box', fontFamily: font.family }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <span style={{ color: palette.texte, fontSize: '26px', letterSpacing: '3px', fontWeight: '900', textTransform: 'uppercase', lineHeight: 1 }}>
          {infos.prenom || c.prenom} <span style={{ color: palette.accent }}>{infos.nom || c.nom}</span>
        </span>
        {infos.agence && <span style={{ color: palette.texte, fontSize: '10px', letterSpacing: '2px', opacity: 0.6, alignSelf: 'center' }}>{infos.agence}</span>}
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '6px', paddingTop: '6px', borderTop: `1px solid ${palette.accent}55` }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ color: palette.accent, fontSize: '10px', letterSpacing: '1px' }}>{infos.email || 'contact@email.com'}</span>
          {infos.telephone && (
            <>
              <span style={{ color: palette.accent, fontSize: '10px', opacity: 0.5 }}>•</span>
              <span style={{ color: palette.accent, fontSize: '10px', letterSpacing: '1px' }}>{infos.telephone}</span>
            </>
          )}
        </div>
        {infos.instagram && <span style={{ color: palette.texte, fontSize: '10px', letterSpacing: '1px', opacity: 0.7 }}>{infos.instagram}</span>}
      </div>
    </div>
  );

  const cc = TRANSLATIONS[compoLang].compoComedien;

  const BandeauVerso = () => {
    if (profile === 'comedien') {
      const items = [
        { label: cc.taille, value: infos.taille || '-', unit: 'cm' },
        { label: cc.poids, value: infos.poids || '-', unit: 'kg' },
        { label: cc.yeux, value: infos.yeux || '-' },
        { label: cc.cheveux, value: infos.cheveux || '-' },
        { label: cc.voix, value: infos.voix || '-' },
        { label: cc.langues, value: infos.langues || '-' },
      ];
      return (
        <div style={{ backgroundColor: palette.bandeau, padding: '10px 24px', flexShrink: 0, boxSizing: 'border-box', fontFamily: font.family }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: infos.demo ? '8px' : '0' }}>
            {items.map((item, i) => (
              <div key={i} style={{ textAlign: 'center', flex: 1 }}>
                <p style={{ margin: 0, fontSize: '9px', letterSpacing: '1.5px', color: palette.accent }}>{item.label}</p>
                <p style={{ margin: '2px 0 0', fontSize: '15px', color: palette.texte, fontWeight: '700', letterSpacing: '1px', lineHeight: 1 }}>
                  {item.value}<span style={{ fontSize: '9px', fontWeight: '400', opacity: 0.6 }}>{item.unit || ''}</span>
                </p>
              </div>
            ))}
          </div>
          {infos.demo && (
            <div style={{ borderTop: `1px solid ${palette.accent}33`, paddingTop: '8px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <span style={{ color: palette.accent, fontSize: '9px', letterSpacing: '2px', fontWeight: '700' }}>▶ {cc.demo}</span>
                <span style={{ color: palette.texte, fontSize: '10px', opacity: 0.6 }}>{infos.demo}</span>
              </div>
              <QRCode value={infos.demo} size={48} fgColor={palette.texte} bgColor={palette.bandeau} />
            </div>
          )}
        </div>
      );
    }
    return (
      <div style={{ backgroundColor: palette.bandeau, padding: '12px 24px', flexShrink: 0, minHeight: '70px', boxSizing: 'border-box', fontFamily: font.family }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '100%' }}>
          {[
            { label: c.taille, value: infos.taille ? `${infos.taille}` : '-', unit: 'cm' },
            { label: c.poitrine, value: infos.poitrine || '-' },
            { label: c.tour_taille, value: infos.tour_taille || '-' },
            { label: c.hanches, value: infos.hanches || '-' },
            { label: c.pointure, value: infos.pointure || '-' },
            { label: c.yeux, value: infos.yeux || '-' },
            { label: c.cheveux, value: infos.cheveux || '-' },
          ].map((item, i) => (
            <div key={i} style={{ textAlign: 'center', flex: 1 }}>
              <p style={{ margin: 0, fontSize: '9px', letterSpacing: '1.5px', color: palette.accent }}>{item.label}</p>
              <p style={{ margin: '2px 0 0', fontSize: '17px', color: palette.texte, fontWeight: '700', letterSpacing: '1px', lineHeight: 1 }}>
                {item.value}<span style={{ fontSize: '10px', fontWeight: '400', opacity: 0.6 }}>{item.unit || ''}</span>
              </p>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderTemplate = (templateId, offset, isRecto) => {
    const s = (i) => offset + i;
    const Bandeau = isRecto ? BandeauRecto : BandeauVerso;
    const row = { display: 'flex', flex: 1, gap: borderGap, backgroundColor: borderBg };
    const col = { display: 'flex', flexDirection: 'column', flex: 1, gap: borderGap, backgroundColor: borderBg };
    switch (templateId) {
      case 't1': return (<><PhotoArea><PhotoSlot slotIndex={s(0)} style={{ flex: 1 }} /></PhotoArea><Bandeau /></>);
      case 't2': return (<><PhotoArea><PhotoSlot slotIndex={s(0)} style={{ flex: 1 }} /><PhotoSlot slotIndex={s(1)} style={{ flex: 1 }} /></PhotoArea><Bandeau /></>);
      case 't3': return (<><PhotoArea><PhotoSlot slotIndex={s(0)} style={{ flex: 2 }} /><div style={{ ...row, flexShrink: 0, height: '33%' }}><PhotoSlot slotIndex={s(1)} style={{ flex: 1 }} /><PhotoSlot slotIndex={s(2)} style={{ flex: 1 }} /></div></PhotoArea><Bandeau /></>);
      case 't4': return (<><PhotoArea><div style={{ ...row, flexShrink: 0, height: '28%' }}><PhotoSlot slotIndex={s(0)} style={{ flex: 1 }} /><PhotoSlot slotIndex={s(1)} style={{ flex: 1 }} /></div><PhotoSlot slotIndex={s(2)} style={{ flex: 1 }} /></PhotoArea><Bandeau /></>);
      case 't5': return (<><PhotoArea><div style={{ ...row, flex: 1 }}><PhotoSlot slotIndex={s(0)} style={{ flex: 1 }} /><PhotoSlot slotIndex={s(1)} style={{ flex: 1 }} /></div><div style={{ ...row, flex: 1 }}><PhotoSlot slotIndex={s(2)} style={{ flex: 1 }} /><PhotoSlot slotIndex={s(3)} style={{ flex: 1 }} /></div></PhotoArea><Bandeau /></>);
      case 't6': return (<><PhotoArea><div style={{ ...row, flex: 1 }}><div style={{ ...col }}><PhotoSlot slotIndex={s(0)} style={{ flex: 1 }} /><PhotoSlot slotIndex={s(1)} style={{ flex: 1 }} /></div><PhotoSlot slotIndex={s(2)} style={{ flex: 1 }} /></div><div style={{ ...row, flex: 1 }}><PhotoSlot slotIndex={s(3)} style={{ flex: 1 }} /><div style={{ ...col }}><PhotoSlot slotIndex={s(4)} style={{ flex: 1 }} /><PhotoSlot slotIndex={s(5)} style={{ flex: 1 }} /></div></div></PhotoArea><Bandeau /></>);
      case 't7': return (<><PhotoArea><div style={{ ...row, flex: 1 }}><PhotoSlot slotIndex={s(0)} style={{ flex: 1 }} /><div style={{ ...col }}><PhotoSlot slotIndex={s(1)} style={{ flex: 1 }} /><PhotoSlot slotIndex={s(2)} style={{ flex: 1 }} /></div></div><div style={{ ...row, flex: 1 }}><div style={{ ...col }}><PhotoSlot slotIndex={s(3)} style={{ flex: 1 }} /><PhotoSlot slotIndex={s(4)} style={{ flex: 1 }} /></div><PhotoSlot slotIndex={s(5)} style={{ flex: 1 }} /></div></PhotoArea><Bandeau /></>);
      case 't8': return (<><PhotoArea><div style={{ ...row, flex: 1 }}><div style={{ ...col }}><div style={{ ...row, flex: 1 }}><PhotoSlot slotIndex={s(0)} style={{ flex: 1 }} /><PhotoSlot slotIndex={s(1)} style={{ flex: 1 }} /></div><div style={{ ...row, flex: 1 }}><PhotoSlot slotIndex={s(2)} style={{ flex: 1 }} /><PhotoSlot slotIndex={s(3)} style={{ flex: 1 }} /></div></div><div style={{ ...col }}><PhotoSlot slotIndex={s(4)} style={{ flex: 1 }} /><PhotoSlot slotIndex={s(5)} style={{ flex: 1 }} /></div></div><div style={{ ...row, flex: 1 }}><div style={{ ...col }}><PhotoSlot slotIndex={s(6)} style={{ flex: 1 }} /><PhotoSlot slotIndex={s(7)} style={{ flex: 1 }} /></div><PhotoSlot slotIndex={s(8)} style={{ flex: 1 }} /></div></PhotoArea><Bandeau /></>);
      default: return (<><PhotoArea><PhotoSlot slotIndex={s(0)} style={{ flex: 1 }} /></PhotoArea><Bandeau /></>);
    }
  };

  const MiniSlot = ({ slotIndex, style }) => {
    const photo = slots[slotIndex];
    return (
      <div style={{ ...style, position: 'relative', overflow: 'hidden', backgroundColor: '#f0f0f0' }}>
        {photo.base64 && (
          <div style={{
            position: 'absolute', inset: 0,
            backgroundImage: `url(${photo.base64})`,
            backgroundSize: 'cover',
            backgroundPosition: `${photo.posX}% ${photo.posY}%`,
            transform: `scale(${photo.zoom})`,
            transformOrigin: `${photo.posX}% ${photo.posY}%`,
          }} />
        )}
      </div>
    );
  };

  const MiniBandeau = ({ isRecto }) => (
    <div style={{ backgroundColor: palette.bandeau, height: '14px', flexShrink: 0, display: 'flex', alignItems: 'center', padding: '0 4px' }}>
      {isRecto && <span style={{ color: palette.texte, fontSize: '4px', fontWeight: '700', letterSpacing: '0.5px', textTransform: 'uppercase', overflow: 'hidden', whiteSpace: 'nowrap' }}>{infos.prenom || 'PRÉNOM'} {infos.nom || 'NOM'}</span>}
    </div>
  );

  const MiniTemplate = ({ templateId, offset, isRecto }) => {
    const s = (i) => offset + i;
    const g = borderEnabled ? `${borderSize * 0.147}px` : '0.5px';
    const bg = borderEnabled ? borderColor : '#fff';
    const row = { display: 'flex', flex: 1, gap: g, backgroundColor: bg };
    const col = { display: 'flex', flexDirection: 'column', flex: 1, gap: g, backgroundColor: bg };
    const area = { flex: 1, display: 'flex', flexDirection: 'column', gap: g, backgroundColor: bg, paddingBottom: '0' };
    switch (templateId) {
      case 't1': return (<><div style={area}><MiniSlot slotIndex={s(0)} style={{ flex: 1 }} /></div><MiniBandeau isRecto={isRecto} /></>);
      case 't2': return (<><div style={area}><MiniSlot slotIndex={s(0)} style={{ flex: 1 }} /><MiniSlot slotIndex={s(1)} style={{ flex: 1 }} /></div><MiniBandeau isRecto={isRecto} /></>);
      case 't3': return (<><div style={area}><MiniSlot slotIndex={s(0)} style={{ flex: 2 }} /><div style={{ ...row, flexShrink: 0, height: '33%' }}><MiniSlot slotIndex={s(1)} style={{ flex: 1 }} /><MiniSlot slotIndex={s(2)} style={{ flex: 1 }} /></div></div><MiniBandeau isRecto={isRecto} /></>);
      case 't4': return (<><div style={area}><div style={{ ...row, flexShrink: 0, height: '28%' }}><MiniSlot slotIndex={s(0)} style={{ flex: 1 }} /><MiniSlot slotIndex={s(1)} style={{ flex: 1 }} /></div><MiniSlot slotIndex={s(2)} style={{ flex: 1 }} /></div><MiniBandeau isRecto={isRecto} /></>);
      case 't5': return (<><div style={area}><div style={{ ...row, flex: 1 }}><MiniSlot slotIndex={s(0)} style={{ flex: 1 }} /><MiniSlot slotIndex={s(1)} style={{ flex: 1 }} /></div><div style={{ ...row, flex: 1 }}><MiniSlot slotIndex={s(2)} style={{ flex: 1 }} /><MiniSlot slotIndex={s(3)} style={{ flex: 1 }} /></div></div><MiniBandeau isRecto={isRecto} /></>);
      case 't6': return (<><div style={area}><div style={{ ...row, flex: 1 }}><div style={{ ...col }}><MiniSlot slotIndex={s(0)} style={{ flex: 1 }} /><MiniSlot slotIndex={s(1)} style={{ flex: 1 }} /></div><MiniSlot slotIndex={s(2)} style={{ flex: 1 }} /></div><div style={{ ...row, flex: 1 }}><MiniSlot slotIndex={s(3)} style={{ flex: 1 }} /><div style={{ ...col }}><MiniSlot slotIndex={s(4)} style={{ flex: 1 }} /><MiniSlot slotIndex={s(5)} style={{ flex: 1 }} /></div></div></div><MiniBandeau isRecto={isRecto} /></>);
      case 't7': return (<><div style={area}><div style={{ ...row, flex: 1 }}><MiniSlot slotIndex={s(0)} style={{ flex: 1 }} /><div style={{ ...col }}><MiniSlot slotIndex={s(1)} style={{ flex: 1 }} /><MiniSlot slotIndex={s(2)} style={{ flex: 1 }} /></div></div><div style={{ ...row, flex: 1 }}><div style={{ ...col }}><MiniSlot slotIndex={s(3)} style={{ flex: 1 }} /><MiniSlot slotIndex={s(4)} style={{ flex: 1 }} /></div><MiniSlot slotIndex={s(5)} style={{ flex: 1 }} /></div></div><MiniBandeau isRecto={isRecto} /></>);
      case 't8': return (<><div style={area}><div style={{ ...row, flex: 1 }}><div style={{ ...col }}><div style={{ ...row, flex: 1 }}><MiniSlot slotIndex={s(0)} style={{ flex: 1 }} /><MiniSlot slotIndex={s(1)} style={{ flex: 1 }} /></div><div style={{ ...row, flex: 1 }}><MiniSlot slotIndex={s(2)} style={{ flex: 1 }} /><MiniSlot slotIndex={s(3)} style={{ flex: 1 }} /></div></div><div style={{ ...col }}><MiniSlot slotIndex={s(4)} style={{ flex: 1 }} /><MiniSlot slotIndex={s(5)} style={{ flex: 1 }} /></div></div><div style={{ ...row, flex: 1 }}><div style={{ ...col }}><MiniSlot slotIndex={s(6)} style={{ flex: 1 }} /><MiniSlot slotIndex={s(7)} style={{ flex: 1 }} /></div><MiniSlot slotIndex={s(8)} style={{ flex: 1 }} /></div></div><MiniBandeau isRecto={isRecto} /></>);
      default: return (<><div style={area}><MiniSlot slotIndex={s(0)} style={{ flex: 1 }} /></div><MiniBandeau isRecto={isRecto} /></>);
    }
  };

  const MiniPreview = ({ templateId, offset, isRecto, label }) => {
    const isCurrent = face === (isRecto ? 'recto' : 'verso');
    return (
      <div onClick={() => setFace(isRecto ? 'recto' : 'verso')}
        style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px' }}>
        <div style={{
          width: isLaptop ? '58px' : '76px', height: isLaptop ? '82px' : '107px', overflow: 'hidden',
          border: `2px solid ${isCurrent ? '#FF0066' : '#ccc'}`,
          backgroundColor: '#fff', flexShrink: 0,
          display: 'flex', flexDirection: 'column'
        }}>
          <MiniTemplate templateId={templateId} offset={offset} isRecto={isRecto} />
        </div>
        <span style={{ fontSize: '10px', fontWeight: '700', letterSpacing: '1.5px', color: isCurrent ? '#FF0066' : '#888' }}>{label}</span>
      </div>
    );
  };

  const THUMB_W = 40;
  const GALLERY_GAP = 4;
  const photosPerRow = isLaptop ? 6 : 8;
  const row1 = gallery.slice(0, photosPerRow);
  const row2 = gallery.slice(photosPerRow);

  const AddButton = () => (
    <div onClick={openGalleryPicker} style={{
      cursor: 'pointer', width: '52px', height: '52px', backgroundColor: '#FF0066',
      borderRadius: '3px', display: 'flex', alignItems: 'center', justifyContent: 'center',
      flexShrink: 0, transition: 'all 0.2s',
    }}
      onMouseEnter={e => e.currentTarget.style.backgroundColor = '#dd0055'}
      onMouseLeave={e => e.currentTarget.style.backgroundColor = '#FF0066'}
    >
      <img src="/PICTO-UPLOAD.svg" alt="Ajouter" style={{ width: '24px', height: '24px', filter: 'brightness(0) invert(1)' }} />
    </div>
  );

  const GalleryThumb = ({ photo, index }) => (
    <div draggable
      onDragStart={(e) => { dragGalleryIndex = index; e.dataTransfer.effectAllowed = 'copy'; }}
      onDragEnd={() => { dragGalleryIndex = null; }}
      style={{ position: 'relative', flexShrink: 0, cursor: 'grab' }}>
      <div style={{ width: `${THUMB_W}px`, height: `${THUMB_W}px`, overflow: 'hidden', border: '1px solid #ccc' }}>
        <img src={photo.url || photo.base64} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
      </div>
      <button onClick={() => removeFromGallery(index)} style={{
        position: 'absolute', top: -4, right: -4, width: '14px', height: '14px',
        backgroundColor: '#FF0066', color: '#fff', border: 'none', borderRadius: '50%',
        cursor: 'pointer', fontSize: '9px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0
      }}>×</button>
    </div>
  );

   

   

  if (!profile) return <ProfileChoice onSelect={setProfile} />;

  return (
    <div style={{ minHeight: '100vh', backgroundColor: BG, fontFamily: 'Arial, sans-serif', display: 'flex', flexDirection: 'column' }}
      onDragOver={e => e.preventDefault()}
      onDrop={e => e.preventDefault()}
    >
      <div id="warning-tip" style={{ display: 'none', position: 'fixed', zIndex: 9999, backgroundColor: '#333', color: '#fff', fontSize: '11px', padding: '6px 10px', borderRadius: '4px', maxWidth: '220px', lineHeight: '1.5', pointerEvents: 'none', boxShadow: '0 2px 8px rgba(0,0,0,0.3)' }}>{warningMsg}</div>

      <div id="editor-top" />
      <Header siteLang={siteLang} setSiteLang={setSiteLang} />

      {showLoadingAd && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 99999, backgroundColor: 'rgba(0,0,0,0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Arial, sans-serif', padding: '24px' }}>
          <div style={{ backgroundColor: '#1A1A1A', color: '#fff', width: '100%', maxWidth: '440px', padding: '40px', position: 'relative', boxShadow: '0 8px 40px rgba(0,0,0,0.6)' }}>
            {[
              { top: 0, left: 0, borderTop: '2px solid #FF0066', borderLeft: '2px solid #FF0066' },
              { top: 0, right: 0, borderTop: '2px solid #FF0066', borderRight: '2px solid #FF0066' },
              { bottom: 0, left: 0, borderBottom: '2px solid #FF0066', borderLeft: '2px solid #FF0066' },
              { bottom: 0, right: 0, borderBottom: '2px solid #FF0066', borderRight: '2px solid #FF0066' },
            ].map((corner, i) => (
              <div key={i} style={{ position: 'absolute', width: '12px', height: '12px', ...corner }} />
            ))}
            <p style={{ color: '#FF0066', fontSize: '11px', letterSpacing: '4px', fontWeight: '700', margin: '0 0 16px' }}>COMPIFY</p>
            <p style={{ fontSize: '16px', fontWeight: '900', margin: '0 0 8px', letterSpacing: '1px' }}>
              {siteLang === 'FR' ? 'Génération de votre composite...' : 'Generating your composite...'}
            </p>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', margin: '0 0 32px' }}>
              <div style={{ flex: 1, height: '4px', backgroundColor: '#2a2a2a', borderRadius: '2px', overflow: 'hidden' }}>
                <div style={{ height: '100%', backgroundColor: '#FF0066', borderRadius: '2px', width: `${loadingProgress}%`, transition: 'width 0.1s linear' }} />
              </div>
              <span style={{ color: '#FF0066', fontSize: '14px', fontWeight: '900', flexShrink: 0 }}>{loadingProgress}%</span>
            </div>
            <div style={{ borderTop: '1px solid #2a2a2a', paddingTop: '24px' }}>
              <p style={{ color: '#888', fontSize: '11px', letterSpacing: '3px', margin: '0 0 16px', fontWeight: '700' }}>
                {siteLang === 'FR' ? 'EN PARTENARIAT AVEC' : 'IN PARTNERSHIP WITH'}
              </p>
              {loadingAd.active && (
                <a href={loadingAd.url ? (loadingAd.url.startsWith('http') ? loadingAd.url : `https://${loadingAd.url}`) : '#'} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '16px' }}>
                  {loadingAd.logo && <img src={loadingAd.logo} alt={loadingAd.name} style={{ height: '48px', objectFit: 'contain', backgroundColor: '#fff', padding: '6px', borderRadius: '4px' }} />}
                  <div>
                    {loadingAd.name && <p style={{ color: '#fff', fontSize: '16px', fontWeight: '900', margin: '0 0 4px', letterSpacing: '1px' }}>{loadingAd.name}</p>}
                    {loadingAd.slogan && <p style={{ color: '#888', fontSize: '12px', margin: 0 }}>{loadingAd.slogan}</p>}
                  </div>
                </a>
              )}
            </div>
          </div>
        </div>
      )}

      {showDownloadTip && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 99999, backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Arial, sans-serif', padding: '24px' }}>
          <div style={{ backgroundColor: '#1A1A1A', color: '#fff', width: '100%', maxWidth: '440px', padding: '40px', position: 'relative', boxShadow: '0 8px 40px rgba(0,0,0,0.6)' }}>
            {[
              { top: 0, left: 0, borderTop: '2px solid #FF0066', borderLeft: '2px solid #FF0066' },
              { top: 0, right: 0, borderTop: '2px solid #FF0066', borderRight: '2px solid #FF0066' },
              { bottom: 0, left: 0, borderBottom: '2px solid #FF0066', borderLeft: '2px solid #FF0066' },
              { bottom: 0, right: 0, borderBottom: '2px solid #FF0066', borderRight: '2px solid #FF0066' },
            ].map((corner, i) => (
              <div key={i} style={{ position: 'absolute', width: '12px', height: '12px', ...corner }} />
            ))}
            <button onClick={() => setShowDownloadTip(false)} style={{ position: 'absolute', top: '16px', right: '16px', backgroundColor: 'transparent', border: 'none', color: '#555', fontSize: '20px', cursor: 'pointer' }}>×</button>
            <p style={{ color: '#FF0066', fontSize: '11px', letterSpacing: '4px', fontWeight: '700', margin: '0 0 16px' }}>COMPIFY</p>
            <p style={{ fontSize: '18px', fontWeight: '900', margin: '0 0 16px', letterSpacing: '1px' }}>
              {siteLang === 'FR' ? 'Votre composite est prêt !' : 'Your composite is ready!'}
            </p>
            <p style={{ color: '#888', fontSize: '13px', lineHeight: 1.7, margin: '0 0 24px' }}>
              {siteLang === 'FR'
                ? 'Si le PDF ne s\'est pas ouvert automatiquement, votre navigateur a peut-être bloqué l\'ouverture. Cliquez sur l\'icône de blocage en haut à droite de votre navigateur et autorisez les popups pour compify.fr.'
                : 'If the PDF did not open automatically, your browser may have blocked it. Click the block icon in the top right of your browser and allow popups for compify.fr.'}
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <button onClick={() => { window.open(pdfBlobUrl, '_blank'); }} style={{ width: '100%', backgroundColor: '#FF0066', color: '#fff', border: 'none', padding: '14px', fontSize: '11px', letterSpacing: '3px', fontWeight: '700', cursor: 'pointer' }}>
                {siteLang === 'FR' ? 'OUVRIR LE PDF' : 'OPEN PDF'}
              </button>
              <button onClick={() => setShowDownloadTip(false)} style={{ width: '100%', backgroundColor: 'transparent', color: '#555', border: '1px solid #333', padding: '12px', fontSize: '11px', letterSpacing: '2px', fontWeight: '700', cursor: 'pointer' }}>
                {siteLang === 'FR' ? 'FERMER' : 'CLOSE'}
              </button>
            </div>
          </div>
        </div>
      )}

      {showPopup && (
        <EmailPopup
          onSuccess={() => { setShowPopup(false); exportPDF(false); }}
          onSkip={() => { setShowPopup(false); exportPDF(true); }}
          onClose={() => setShowPopup(false)}
          siteLang={siteLang}
        />
      )}

      <div style={{ flex: 1, display: 'flex', justifyContent: 'center', padding: '16px' }}>
        <div style={{ display: 'flex', alignItems: 'stretch', backgroundColor: '#c8c8c8', padding: '12px', gap: '12px', width: 'fit-content', margin: '0 auto', boxShadow: '0 4px 24px rgba(0,0,0,0.3)' }}>

          {/* COLONNE 1 et 2 — inversées en mode laptop */}
          {isLaptop && (
            <div style={{ width: PANEL_W, flexShrink: 0, display: 'flex', flexDirection: 'column', position: 'relative', maxHeight: 'calc(100vh - 112px)', overflowY: 'auto' }}>
              <div style={{ background: PANEL_BG, padding: '8px', flex: 1 }}>
                <Block>
                  <div onClick={() => setFontOpen(prev => !prev)}
                    style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                    <SectionLabel text="POLICE" />
                    <span style={{ color: '#888', fontSize: '12px', marginTop: '-10px', marginBottom: '10px' }}>{fontOpen ? '▲' : '▼'}</span>
                  </div>
                  {fontOpen && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      {FONTS.map(f => (
                        <div key={f.name} onClick={() => setFont(f)}
                          style={{
                            padding: '6px 10px', cursor: 'pointer', borderRadius: '3px',
                            backgroundColor: font.name === f.name ? 'rgba(255,0,102,0.1)' : 'rgba(255,255,255,0.5)',
                            border: `1.5px solid ${font.name === f.name ? '#FF0066' : 'rgba(0,0,0,0.1)'}`,
                            fontFamily: f.family, fontSize: '13px',
                            color: font.name === f.name ? '#FF0066' : '#555',
                            transition: 'all 0.2s'
                          }}>
                          {f.label}
                        </div>
                      ))}
                    </div>
                  )}
                </Block>
                <Block>
                  <SectionLabel text={t.colors} />
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '4px', marginBottom: '8px' }}>
                    {PALETTES.map(p => (
                      <div key={p.name} onClick={() => setPalette(p)} style={{ cursor: 'pointer', borderRadius: '3px', overflow: 'hidden', border: `1.5px solid ${palette.name === p.name ? '#FF0066' : 'rgba(0,0,0,0.1)'}`, transition: 'all 0.2s' }}>
                        <div style={{ height: '16px', backgroundColor: p.bandeau }} />
                        <div style={{ height: '6px', backgroundColor: p.accent }} />
                        <p style={{ margin: 0, fontSize: '8px', textAlign: 'center', padding: '2px', color: '#777', backgroundColor: 'rgba(255,255,255,0.6)' }}>{p.name}</p>
                      </div>
                    ))}
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <label style={{ fontSize: '11px', color: '#777', width: '40px' }}>{t.fond}</label>
                      <input type="color" value={palette.bandeau} onChange={e => setPalette(prev => ({ ...prev, bandeau: e.target.value }))} style={{ width: '24px', height: '20px', border: '1px solid rgba(0,0,0,0.1)', borderRadius: '2px', cursor: 'pointer', padding: '1px' }} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <label style={{ fontSize: '11px', color: '#777', width: '40px' }}>{t.accent}</label>
                      <input type="color" value={palette.accent} onChange={e => setPalette(prev => ({ ...prev, accent: e.target.value }))} style={{ width: '24px', height: '20px', border: '1px solid rgba(0,0,0,0.1)', borderRadius: '2px', cursor: 'pointer', padding: '1px' }} />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <label style={{ fontSize: '11px', color: '#777', width: '40px' }}>{t.texte || 'TEXTE'}</label>
                      <input type="color" value={palette.texte} onChange={e => setPalette(prev => ({ ...prev, texte: e.target.value }))} style={{ width: '24px', height: '20px', border: '1px solid rgba(0,0,0,0.1)', borderRadius: '2px', cursor: 'pointer', padding: '1px' }} />
                    </div>
                  </div>
                </Block>
                <Block>
                  <SectionLabel text={t.border} />
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                    <label style={{ fontSize: '11px', color: '#777', flex: 1 }}>{t.enable}</label>
                    <Toggle value={borderEnabled} onChange={setBorderEnabled} />
                  </div>
                  {borderEnabled && (
                    <>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '8px' }}>
                        <label style={{ fontSize: '11px', color: '#777' }}>{t.color}</label>
                        <input type="color" value={borderColor} onChange={e => setBorderColor(e.target.value)} style={{ width: '24px', height: '20px', border: '1px solid rgba(0,0,0,0.1)', borderRadius: '2px', cursor: 'pointer', padding: '1px' }} />
                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                        <label style={{ fontSize: '11px', color: '#777' }}>{t.thickness}</label>
                        <div style={{ display: 'flex', gap: '3px' }}>
                          {[1, 2, 4, 8].map(size => (
                            <button key={size} onClick={() => setBorderSize(size)} style={{
                              width: '20px', height: '20px',
                              border: `1.5px solid ${borderSize === size ? '#FF0066' : 'rgba(0,0,0,0.15)'}`,
                              borderRadius: '3px', cursor: 'pointer', fontSize: '9px', fontWeight: '700',
                              backgroundColor: borderSize === size ? 'rgba(255,0,102,0.08)' : 'rgba(255,255,255,0.5)',
                              color: borderSize === size ? '#FF0066' : '#888'
                            }}>{size}</button>
                          ))}
                        </div>
                      </div>
                    </>
                  )}
                </Block>
                <AdSlot id="ad-editor-sidebar-left-1" />
              </div>
            </div>
          )}
          <div style={{ width: PANEL_W, flexShrink: 0, display: 'flex', flexDirection: 'column', position: 'relative', maxHeight: 'calc(100vh - 112px)', overflowY: 'auto' }}>
            {!isLaptop && (
              <div style={{ backgroundColor: '#1A1A1A', width: '100%', aspectRatio: '1', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '8px', flexShrink: 0 }}>
                <img src="/logo-compify.svg" alt="Compify" style={{ width: '75%', height: 'auto', display: 'block', margin: 'auto' }} />
              </div>
            )}
            <div style={{ background: PANEL_BG, padding: '8px', flex: 1 }}>
              {isLaptop && (
                <>
                <Block>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: gallery.length > 0 ? '6px' : '0' }}>
                    <div onClick={openGalleryPicker} style={{
                      cursor: 'pointer', width: `${THUMB_W}px`, height: `${THUMB_W}px`,
                      backgroundColor: '#FF0066', borderRadius: '3px',
                      display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                    }}
                      onMouseEnter={e => e.currentTarget.style.backgroundColor = '#dd0055'}
                      onMouseLeave={e => e.currentTarget.style.backgroundColor = '#FF0066'}
                    >
                      <img src="/PICTO-UPLOAD.svg" alt="Ajouter" style={{ width: '18px', height: '18px', filter: 'brightness(0) invert(1)' }} />
                    </div>
                    {gallery.length > 0 && (
                      <span style={{ color: '#1A1A1A', fontSize: '10px', fontWeight: '700', letterSpacing: '1px' }}>
                        {gallery.length}/16
                      </span>
                    )}
                    {gallery.length === 0 && (
                      <span style={{ color: '#aaa', fontSize: '10px', fontStyle: 'italic' }}>{t.dragHint}</span>
                    )}
                  </div>
                  {gallery.length > 0 && (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: `${GALLERY_GAP}px` }}>
                      {gallery.map((photo, i) => <GalleryThumb key={i} photo={photo} index={i} />)}
                    </div>
                  )}
                </Block>
                <AdSlot id="ad-editor-sidebar-left-2" />
                <div style={{ height: '8px' }} />
                </>
              )}
              <Block>
                <SectionLabel text={t.compoLang} />
                <div style={{ display: 'flex', border: '1px solid rgba(0,0,0,0.1)', borderRadius: '3px', overflow: 'hidden' }}>
                  {['FR', 'EN'].map(lang => (
                    <button key={lang} onClick={() => setCompoLang(lang)} style={{ flex: 1, padding: '6px', border: 'none', cursor: 'pointer', fontSize: '11px', fontWeight: '700', backgroundColor: compoLang === lang ? '#FF0066' : 'rgba(255,255,255,0.5)', color: compoLang === lang ? '#fff' : '#888', transition: 'all 0.2s' }}>{lang}</button>
                  ))}
                </div>
              </Block>
              <Block>
                <SectionLabel text={t.face} />
                <div style={{ display: 'flex', justifyContent: 'space-around', gap: '8px' }}>
                  {['recto', 'verso'].map(f => (
                    <div key={f} onClick={() => setFace(f)} style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px' }}>
                      <div style={{
                        width: isLaptop ? '58px' : '76px', height: isLaptop ? '82px' : '107px',
                        backgroundColor: face === f ? '#FF0066' : 'rgba(255,255,255,0.5)',
                        border: face === f ? 'none' : '1px solid rgba(0,0,0,0.1)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        transition: 'all 0.2s'
                      }}>
                        <span style={{ fontSize: '10px', fontWeight: '700', letterSpacing: '1.5px', color: face === f ? '#fff' : '#888' }}>
                          {f === 'recto' ? t.recto : t.verso}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </Block>
              <Block>
                <SectionLabel text={face === 'recto' ? 'TEMPLATES RECTO' : 'TEMPLATES VERSO'} />
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '4px' }}>
                  {TEMPLATES.map(tmpl => (
                    <div key={tmpl.id}
                      onClick={() => { face === 'recto' ? setRectoTemplate(tmpl.id) : setVersoTemplate(tmpl.id); }}
                      title={tmpl.name}
                      style={{ cursor: 'pointer', aspectRatio: '44/60', overflow: 'hidden', transition: 'all 0.2s', opacity: (face === 'recto' ? rectoTemplate : versoTemplate) === tmpl.id ? 1 : 0.5, position: 'relative' }}>
                      <TemplateVignette id={tmpl.id} active={(face === 'recto' ? rectoTemplate : versoTemplate) === tmpl.id} />
                      {(face === 'recto' ? rectoTemplate : versoTemplate) === tmpl.id && (
                        <div style={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(255,0,102,0.15)', pointerEvents: 'none' }} />
                      )}
                    </div>
                  ))}
                </div>
              </Block>
               
              {!isLaptop && (
                <>
                  <Block>
                    <div onClick={() => setFontOpen(prev => !prev)}
                      style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                      <SectionLabel text="POLICE" />
                      <span style={{ color: '#888', fontSize: '12px', marginTop: '-10px', marginBottom: '10px' }}>{fontOpen ? '▲' : '▼'}</span>
                    </div>
                    {fontOpen && (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                        {FONTS.map(f => (
                          <div key={f.name} onClick={() => setFont(f)}
                            style={{
                              padding: '6px 10px', cursor: 'pointer', borderRadius: '3px',
                              backgroundColor: font.name === f.name ? 'rgba(255,0,102,0.1)' : 'rgba(255,255,255,0.5)',
                              border: `1.5px solid ${font.name === f.name ? '#FF0066' : 'rgba(0,0,0,0.1)'}`,
                              fontFamily: f.family, fontSize: '13px',
                              color: font.name === f.name ? '#FF0066' : '#555',
                              transition: 'all 0.2s'
                            }}>
                            {f.label}
                          </div>
                        ))}
                      </div>
                    )}
                  </Block>
                  <Block>
                    <SectionLabel text={t.colors} />
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '4px', marginBottom: '8px' }}>
                      {PALETTES.map(p => (
                        <div key={p.name} onClick={() => setPalette(p)} style={{ cursor: 'pointer', borderRadius: '3px', overflow: 'hidden', border: `1.5px solid ${palette.name === p.name ? '#FF0066' : 'rgba(0,0,0,0.1)'}`, transition: 'all 0.2s' }}>
                          <div style={{ height: '16px', backgroundColor: p.bandeau }} />
                          <div style={{ height: '6px', backgroundColor: p.accent }} />
                          <p style={{ margin: 0, fontSize: '8px', textAlign: 'center', padding: '2px', color: '#777', backgroundColor: 'rgba(255,255,255,0.6)' }}>{p.name}</p>
                        </div>
                      ))}
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <label style={{ fontSize: '11px', color: '#777', width: '40px' }}>{t.fond}</label>
                        <input type="color" value={palette.bandeau} onChange={e => setPalette(prev => ({ ...prev, bandeau: e.target.value }))} style={{ width: '24px', height: '20px', border: '1px solid rgba(0,0,0,0.1)', borderRadius: '2px', cursor: 'pointer', padding: '1px' }} />
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <label style={{ fontSize: '11px', color: '#777', width: '40px' }}>{t.accent}</label>
                        <input type="color" value={palette.accent} onChange={e => setPalette(prev => ({ ...prev, accent: e.target.value }))} style={{ width: '24px', height: '20px', border: '1px solid rgba(0,0,0,0.1)', borderRadius: '2px', cursor: 'pointer', padding: '1px' }} />
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <label style={{ fontSize: '11px', color: '#777', width: '40px' }}>{t.texte || 'TEXTE'}</label>
                        <input type="color" value={palette.texte} onChange={e => setPalette(prev => ({ ...prev, texte: e.target.value }))} style={{ width: '24px', height: '20px', border: '1px solid rgba(0,0,0,0.1)', borderRadius: '2px', cursor: 'pointer', padding: '1px' }} />
                      </div>
                    </div>
                  </Block>
                  <Block>
                    <SectionLabel text={t.border} />
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                      <label style={{ fontSize: '11px', color: '#777', flex: 1 }}>{t.enable}</label>
                      <Toggle value={borderEnabled} onChange={setBorderEnabled} />
                    </div>
                    {borderEnabled && (
                      <>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '8px' }}>
                          <label style={{ fontSize: '11px', color: '#777' }}>{t.color}</label>
                          <input type="color" value={borderColor} onChange={e => setBorderColor(e.target.value)} style={{ width: '24px', height: '20px', border: '1px solid rgba(0,0,0,0.1)', borderRadius: '2px', cursor: 'pointer', padding: '1px' }} />
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <label style={{ fontSize: '11px', color: '#777' }}>{t.thickness}</label>
                          <div style={{ display: 'flex', gap: '4px' }}>
                            {[1, 2, 4, 8].map(size => (
                              <button key={size} onClick={() => setBorderSize(size)} style={{
                                width: '24px', height: '20px',
                                border: `1.5px solid ${borderSize === size ? '#FF0066' : 'rgba(0,0,0,0.15)'}`,
                                borderRadius: '3px', cursor: 'pointer', fontSize: '10px', fontWeight: '700',
                                backgroundColor: borderSize === size ? 'rgba(255,0,102,0.08)' : 'rgba(255,255,255,0.5)',
                                color: borderSize === size ? '#FF0066' : '#888'
                              }}>{size}</button>
                            ))}
                          </div>
                        </div>
                      </>
                    )}
                  </Block>
                  <AdSlot id="ad-editor-sidebar-left-1" />
                  <div style={{ height: '8px' }} />
                  <AdSlot id="ad-editor-sidebar-left-2" />
                </>
              )}
            </div>
          </div>

          {/* COMPOSITE CENTRE */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '0 16px' }}>
            {!isLaptop && (
              <div style={{ width: `${COMPO_W}px`, marginBottom: '10px' }}>
                <Block style={{ marginBottom: 0, overflow: 'hidden' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', flexShrink: 0 }}>
                      <AddButton />
                      {gallery.length > 0 && (
                        <span style={{ color: '#1A1A1A', fontSize: '10px', fontWeight: '700', letterSpacing: '1px' }}>
                          {gallery.length}/16
                        </span>
                      )}
                    </div>
                    <div style={{ width: '1px', alignSelf: 'stretch', backgroundColor: 'rgba(0,0,0,0.1)', flexShrink: 0 }} />
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '5px' }}>
                      <div style={{ display: 'flex', gap: `${GALLERY_GAP}px`, alignItems: 'center' }}>
                        {row1.map((photo, i) => <GalleryThumb key={i} photo={photo} index={i} />)}
                      </div>
                      {row2.length > 0 && (
                        <div style={{ display: 'flex', gap: `${GALLERY_GAP}px` }}>
                          {row2.map((photo, i) => <GalleryThumb key={i} photo={photo} index={photosPerRow + i} />)}
                        </div>
                      )}
                      {gallery.length === 0 && (
                        <span style={{ color: '#aaa', fontSize: '11px', fontStyle: 'italic' }}>{t.dragHint}</span>
                      )}
                    </div>
                  </div>
                </Block>
              </div>
            )}

            {!isLaptop && (
              <div style={{ width: `${COMPO_W}px`, marginBottom: '10px', overflow: 'hidden' }}>
                <div style={{ transform: `scaleX(${COMPO_W / 600})`, transformOrigin: 'left center' }}>
                  <AdSlot id="ad-editor-top" />
                </div>
              </div>
            )}

            <div style={{ position: 'relative', marginTop: '0', width: `${COMPO_W}px` }}>
              <img src="/bas-gauche.png" alt="" style={{ position: 'absolute', top: '100%', left: 0, marginTop: '2px', pointerEvents: 'none', zIndex: 10, transform: isLaptop ? 'scale(0.8)' : 'none', transformOrigin: 'top left' }} />
              <img src="/bas-droite.png" alt="" style={{ position: 'absolute', top: '100%', right: 0, marginTop: '2px', pointerEvents: 'none', zIndex: 10, transform: isLaptop ? 'scale(0.8)' : 'none', transformOrigin: 'top right' }} />
              <img src="/cote-gauche.png" alt="" style={{ position: 'absolute', bottom: -2, left: -2, transform: isLaptop ? 'translateX(-100%) scale(0.8)' : 'translateX(-100%)', transformOrigin: 'bottom right', pointerEvents: 'none', zIndex: 10 }} />
              <img src="/cote-droit.png" alt="" style={{ position: 'absolute', bottom: -2, right: -2, transform: isLaptop ? 'translateX(100%) scale(0.8)' : 'translateX(100%)', transformOrigin: 'bottom left', pointerEvents: 'none', zIndex: 10 }} />
              <div id="composite-preview"
                onMouseEnter={() => { document.body.style.overflowY = 'hidden'; }}
                onMouseLeave={() => { document.body.style.overflowY = 'auto'; }}
                style={{ width: `${COMPO_W}px`, height: `${COMPO_H}px`, backgroundColor: '#fff', boxShadow: '0 8px 40px rgba(0,0,0,0.4)', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                {renderTemplate(currentTemplate, currentOffset, face === 'recto')}
              </div>
            </div>

            <div style={{ width: `${COMPO_W}px`, marginTop: '32px' }}>
              <button onClick={() => exportPDF()} disabled={exporting} style={{
                width: '100%', backgroundColor: exporting ? '#555' : '#FF0066',
                color: '#fff', border: 'none', padding: '20px 24px',
                fontSize: '11px', letterSpacing: '4px', cursor: exporting ? 'not-allowed' : 'pointer',
                fontWeight: '900', transition: 'all 0.2s', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px'
              }}
                onMouseEnter={e => { if (!exporting) e.currentTarget.style.backgroundColor = '#dd0055'; }}
                onMouseLeave={e => { if (!exporting) e.currentTarget.style.backgroundColor = '#FF0066'; }}
              >
                {exporting ? (
                  <><span style={{ fontSize: '14px' }}>⏳</span>{t.generating}</>
                ) : (
                  <>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
                    </svg>
                    {t.download}
                  </>
                )}
              </button>
            </div>
          </div>

          {/* COLONNE 4 */}
          <div style={{ width: PANEL_W, flexShrink: 0, display: 'flex', flexDirection: 'column', position: 'relative', maxHeight: 'calc(100vh - 112px)', overflowY: 'auto' }}>
            <div style={{ background: PANEL_BG, padding: '8px', height: '100%' }}>
              <Block>
                <SectionLabel text={t.preview} />
                <div style={{ display: 'flex', justifyContent: 'space-around', gap: '8px' }}>
                  <MiniPreview templateId={rectoTemplate} offset={0} isRecto={true} label={t.recto} />
                  <MiniPreview templateId={versoTemplate} offset={10} isRecto={false} label={t.verso} />
                </div>
              </Block>
              <Block>
                <SectionLabel text={t.infos} />
                {profile === 'comedien' ? (
                  Object.entries(TRANSLATIONS[siteLang].site.fieldsComedien)
                    .filter(([key]) => isLaptop ? ['prenom', 'nom', 'email', 'telephone', 'agence', 'instagram'].includes(key) : true)
                    .map(([key, label]) => (
                    <div key={key} style={{ marginBottom: '7px' }}>
                      <label style={{ fontSize: '11px', color: '#666', display: 'block', marginBottom: '3px', fontWeight: '500' }}>{label}</label>
                      <input type="text" value={infos[key] || ''} onChange={e => handleInfo(key, e.target.value)}
                        placeholder=''
                        style={{ width: '100%', padding: '5px 7px', border: '1px solid rgba(0,0,0,0.1)', borderRadius: '3px', fontSize: '12px', backgroundColor: 'rgba(255,255,255,0.7)', color: '#333', boxSizing: 'border-box', outline: 'none' }} />
                    </div>
                  ))
                ) : (
                  <>
                    <div style={{ marginBottom: '7px' }}>
                      <label style={{ fontSize: '11px', color: '#666', display: 'block', marginBottom: '5px', fontWeight: '500' }}>Agence / Site web</label>
                      <input type="text" value={infos.agence || ''} onChange={e => handleInfo('agence', e.target.value)}
                        placeholder=''
                        style={{ width: '100%', padding: '5px 7px', border: '1px solid rgba(0,0,0,0.1)', borderRadius: '3px', fontSize: '12px', backgroundColor: 'rgba(255,255,255,0.7)', color: '#333', boxSizing: 'border-box', outline: 'none' }} />
                    </div>
                    {fields.filter(f => isLaptop 
                      ? ['prenom', 'nom', 'email', 'telephone', 'instagram'].includes(f.key)
                      : f.key !== 'agence'
                    ).map(field => (
                      <div key={field.key} style={{ marginBottom: isLaptop ? '4px' : '7px' }}>
                        <label style={{ fontSize: '11px', color: '#666', display: 'block', marginBottom: '3px', fontWeight: '500' }}>{field.label}</label>
                        <input type="text" value={infos[field.key] || ''} onChange={e => handleInfo(field.key, e.target.value)}
                          placeholder=''
                          style={{ width: '100%', padding: '5px 7px', border: '1px solid rgba(0,0,0,0.1)', borderRadius: '3px', fontSize: '12px', backgroundColor: 'rgba(255,255,255,0.7)', color: '#333', boxSizing: 'border-box', outline: 'none' }} />
                      </div>
                    ))}
                  </>
                )}
              </Block>
              {!isLaptop && (
                <div style={{ flex: 1, minHeight: '120px' }}>
                  <AdSlot id="ad-editor-sidebar-right" />
                </div>
              )}
            </div>
          </div>

          {/* COLONNE 5 — seulement en mode laptop */}
          {isLaptop && (
            <div style={{ width: PANEL_W, flexShrink: 0, display: 'flex', flexDirection: 'column', position: 'relative', maxHeight: 'calc(100vh - 112px)', overflowY: 'auto', flex: '0 0 ' + PANEL_W }}>
              <div style={{ background: PANEL_BG, padding: '8px', height: '100%' }}>
                {!isLaptop && (
                  <Block>
                    <SectionLabel text="POLICE" />
                    <div onClick={() => setFontOpen(prev => !prev)} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', marginBottom: '4px' }}>
                      <span style={{ fontSize: '11px', color: '#666' }}>{font.label}</span>
                      <span style={{ color: '#888', fontSize: '12px' }}>{fontOpen ? '▲' : '▼'}</span>
                    </div>
                    {fontOpen && (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                        {FONTS.map(f => (
                          <div key={f.name} onClick={() => setFont(f)}
                            style={{
                              padding: '6px 10px', cursor: 'pointer', borderRadius: '3px',
                              backgroundColor: font.name === f.name ? 'rgba(255,0,102,0.1)' : 'rgba(255,255,255,0.5)',
                              border: `1.5px solid ${font.name === f.name ? '#FF0066' : 'rgba(0,0,0,0.1)'}`,
                              fontFamily: f.family, fontSize: '13px',
                              color: font.name === f.name ? '#FF0066' : '#555',
                            }}>
                            {f.label}
                          </div>
                        ))}
                      </div>
                    )}
                  </Block>
                )}
                <Block>
                  <SectionLabel text={profile === 'comedien' ? 'CARACTÉRISTIQUES' : 'MENSURATIONS'} />
                  {profile === 'comedien' ? (
                    ['taille', 'poids', 'yeux', 'cheveux', 'voix', 'langues', 'demo'].map(key => (
                      <div key={key} style={{ marginBottom: '7px' }}>
                        <label style={{ fontSize: '11px', color: '#666', display: 'block', marginBottom: '3px', fontWeight: '500' }}>{TRANSLATIONS[siteLang].site.fieldsComedien[key]}</label>
                        <input type="text" value={infos[key] || ''} onChange={e => handleInfo(key, e.target.value)}
                          placeholder={key === 'demo' ? 'https://...' : ''}
                          style={{ width: '100%', padding: '5px 7px', border: '1px solid rgba(0,0,0,0.1)', borderRadius: '3px', fontSize: '12px', backgroundColor: 'rgba(255,255,255,0.7)', color: '#333', boxSizing: 'border-box', outline: 'none' }} />
                      </div>
                    ))
                  ) : (
                    fields.filter(f => ['taille', 'poitrine', 'tour_taille', 'hanches', 'pointure', 'yeux', 'cheveux'].includes(f.key)).map(field => (
                      <div key={field.key} style={{ marginBottom: '4px' }}>
                        <label style={{ fontSize: '11px', color: '#666', display: 'block', marginBottom: '3px', fontWeight: '500' }}>{field.label}</label>
                        <input type="text" value={infos[field.key] || ''} onChange={e => handleInfo(field.key, e.target.value)}
                          placeholder=''
                          style={{ width: '100%', padding: '5px 7px', border: '1px solid rgba(0,0,0,0.1)', borderRadius: '3px', fontSize: '12px', backgroundColor: 'rgba(255,255,255,0.7)', color: '#333', boxSizing: 'border-box', outline: 'none' }} />
                      </div>
                    ))
                  )}
                </Block>
                <AdSlot id="ad-editor-sidebar-right" />
              </div>
            </div>
          )}

        </div>
      </div>

      <Footer siteLang={siteLang} />
    </div>
  );
}

export default Editor;